import { TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { stringToDate } from 'src/utils/date-utils';
import React from 'react';
import { useAuth } from '../../hooks/useAuth';

type Props = {
    value: string,
    label: string,
    error?: boolean,
    onChange: (updatedValue: string) => void
}

const CustomDatePicker = ({ value, onChange, label, error = false }: Props) => {
    const { user } = useAuth();
    const culture = user?.culture ?? 'en-US';
    const dateFormat = user?.dateFormat ?? 'M/D/YYYY';
    const timezone = user?.timezone ?? "America/New_York"
    const [dateFormatError, setDateFormatError] = React.useState(false);

    const onDateChange = (date: Date) => {
        setDateFormatError(false);

        try {
            const dateString = date.toISOString();
            onChange(dateString);
        }
        catch (err) {
            setDateFormatError(true);
        }
    }

    const onKeyDown = (e: any) => {
        e.preventDefault();
    };

    return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker label={label}
            inputFormat={dateFormat}
            value={stringToDate(value)}
            onChange={onDateChange}
            renderInput={(params) => <TextField {...params} size='small' error={error || dateFormatError} onKeyDown={onKeyDown} />} />
    </LocalizationProvider>
}

export { CustomDatePicker }
export default CustomDatePicker